import { routes } from '@/navigation/routes.tsx';
import i18n from '@/i18n.tsx';

export const handleUserBanned = () => {
  const lang = i18n.language;
  const url = `${routes.banned}?lang=${lang}`;
  window.location.replace(url);
};
